export function getPojazdLabel(count: number | null | undefined): string {
    if (typeof count !== 'number' || isNaN(count)) return 'pojazdów';
    const absCount = Math.abs(count);

    if (absCount === 1) return 'pojazd';
    if ([2, 3, 4].includes(absCount % 10) && ![12, 13, 14].includes(absCount % 100)) {
        return 'pojazdy';
    }
    return 'pojazdów';
}
